<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="статус"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getLocationStatus"
      :get-list="getItems"
      :can-create-catalog="canCreateLocationStatus()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <location-status
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import LocationStatus from "./LocationStatus.vue"
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "LocationStatusSelect",
  components: { CatalogSelect, LocationStatus },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getLocationStatusesSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getLocationStatus(id) {
      const result = await this.getLocationStatusById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canCreateLocationStatus() {
      return this.hasPermission([PERM.CATALOG_LOCATION_STATUS_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LocationStatuses/LocationStatusSelect.vue